// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== Las dos formas de recibir ===== */
.DeliveryHours_modes__LDrjq {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin: 0 0 14px;
  padding: 0;
  border: none;
}
.DeliveryHours_legend__YZ5r3 {
  /* La leyenda existe para el lector de pantalla: la pantalla ya tiene el título de la tarjeta. */
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
.DeliveryHours_mode__I6tfW {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid var(--dylo-surface-border);
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.DeliveryHours_mode__I6tfW:hover {
  background: color-mix(in srgb, var(--dylo-orange) 4%, transparent);
}
.DeliveryHours_modeOn__i150E {
  border-color: color-mix(in srgb, var(--dylo-orange) 70%, transparent);
  background: color-mix(in srgb, var(--dylo-orange) 7%, transparent);
}
.DeliveryHours_modeInput__s98\\+P {
  margin: 3px 0 0;
  accent-color: var(--dylo-orange);
}
.DeliveryHours_modeText__mEjyR {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.DeliveryHours_modeLabel__jxaMf {
  font-size: 13.5px;
  font-weight: 600;
  color: var(--dylo-ink);
}
.DeliveryHours_modeDesc__-FAYv {
  font-size: 12px;
  color: var(--dylo-muted);
  line-height: 1.45;
}

/* ===== Las horas ===== */
.DeliveryHours_hoursBlock__eW-Lr {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid color-mix(in srgb, var(--dylo-surface-border) 80%, transparent);
  margin-bottom: 4px;
}
.DeliveryHours_fieldLabel__XT8zX {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.4px;
  text-transform: uppercase;
  color: var(--dylo-muted);
}
.DeliveryHours_times__zLl3w {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.DeliveryHours_time__Oqo0h {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: 132px;
}
.DeliveryHours_removeBtn__aCFad,
.DeliveryHours_addBtn__1Qsea {
  border: 1px solid var(--dylo-surface-border);
  background: transparent;
  color: var(--dylo-muted);
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
}
.DeliveryHours_removeBtn__aCFad {
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  line-height: 1;
}
.DeliveryHours_addBtn__1Qsea {
  padding: 6px 10px;
  font-weight: 600;
}
.DeliveryHours_removeBtn__aCFad:hover:not(:disabled),
.DeliveryHours_addBtn__1Qsea:hover:not(:disabled) {
  color: var(--dylo-ink);
  border-color: color-mix(in srgb, var(--dylo-orange) 60%, transparent);
}
.DeliveryHours_removeBtn__aCFad:disabled,
.DeliveryHours_addBtn__1Qsea:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.DeliveryHours_zone__wkuAu {
  max-width: 280px;
}
.DeliveryHours_hint__WjuDv {
  font-size: 12px;
  color: var(--dylo-muted);
  line-height: 1.45;
  margin: 0;
}

@media (max-width: 700px) {
  /* \`minmax(0, 1fr)\` y no \`1fr\` (26-oct-2026): ver la nota del mismo cambio en \`Profile.module.css\`. */
  .DeliveryHours_modes__LDrjq {
    grid-template-columns: minmax(0, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/pages/Profile/DeliveryHours.module.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;AACA;EACE,gGAAgG;EAChG,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,kEAAkE;AACpE;AACA;EACE,qEAAqE;EACrE,kEAAkE;AACpE;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,iFAAiF;EACjF,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;AACA;;EAEE,4CAA4C;EAC5C,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;EACtB,qEAAqE;AACvE;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,wBAAwB;EACxB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,qGAAqG;EACrG;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* ===== Las dos formas de recibir ===== */\n.modes {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n  margin: 0 0 14px;\n  padding: 0;\n  border: none;\n}\n.legend {\n  /* La leyenda existe para el lector de pantalla: la pantalla ya tiene el título de la tarjeta. */\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  white-space: nowrap;\n}\n.mode {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid var(--dylo-surface-border);\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n}\n.mode:hover {\n  background: color-mix(in srgb, var(--dylo-orange) 4%, transparent);\n}\n.modeOn {\n  border-color: color-mix(in srgb, var(--dylo-orange) 70%, transparent);\n  background: color-mix(in srgb, var(--dylo-orange) 7%, transparent);\n}\n.modeInput {\n  margin: 3px 0 0;\n  accent-color: var(--dylo-orange);\n}\n.modeText {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.modeLabel {\n  font-size: 13.5px;\n  font-weight: 600;\n  color: var(--dylo-ink);\n}\n.modeDesc {\n  font-size: 12px;\n  color: var(--dylo-muted);\n  line-height: 1.45;\n}\n\n/* ===== Las horas ===== */\n.hoursBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  border: 1px solid color-mix(in srgb, var(--dylo-surface-border) 80%, transparent);\n  margin-bottom: 4px;\n}\n.fieldLabel {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.4px;\n  text-transform: uppercase;\n  color: var(--dylo-muted);\n}\n.times {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n}\n.time {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  width: 132px;\n}\n.removeBtn,\n.addBtn {\n  border: 1px solid var(--dylo-surface-border);\n  background: transparent;\n  color: var(--dylo-muted);\n  border-radius: 8px;\n  font-size: 12px;\n  cursor: pointer;\n}\n.removeBtn {\n  width: 26px;\n  height: 26px;\n  flex: 0 0 26px;\n  line-height: 1;\n}\n.addBtn {\n  padding: 6px 10px;\n  font-weight: 600;\n}\n.removeBtn:hover:not(:disabled),\n.addBtn:hover:not(:disabled) {\n  color: var(--dylo-ink);\n  border-color: color-mix(in srgb, var(--dylo-orange) 60%, transparent);\n}\n.removeBtn:disabled,\n.addBtn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n.zone {\n  max-width: 280px;\n}\n.hint {\n  font-size: 12px;\n  color: var(--dylo-muted);\n  line-height: 1.45;\n  margin: 0;\n}\n\n@media (max-width: 700px) {\n  /* `minmax(0, 1fr)` y no `1fr` (26-oct-2026): ver la nota del mismo cambio en `Profile.module.css`. */\n  .modes {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modes": `DeliveryHours_modes__LDrjq`,
	"legend": `DeliveryHours_legend__YZ5r3`,
	"mode": `DeliveryHours_mode__I6tfW`,
	"modeOn": `DeliveryHours_modeOn__i150E`,
	"modeInput": `DeliveryHours_modeInput__s98+P`,
	"modeText": `DeliveryHours_modeText__mEjyR`,
	"modeLabel": `DeliveryHours_modeLabel__jxaMf`,
	"modeDesc": `DeliveryHours_modeDesc__-FAYv`,
	"hoursBlock": `DeliveryHours_hoursBlock__eW-Lr`,
	"fieldLabel": `DeliveryHours_fieldLabel__XT8zX`,
	"times": `DeliveryHours_times__zLl3w`,
	"time": `DeliveryHours_time__Oqo0h`,
	"removeBtn": `DeliveryHours_removeBtn__aCFad`,
	"addBtn": `DeliveryHours_addBtn__1Qsea`,
	"zone": `DeliveryHours_zone__wkuAu`,
	"hint": `DeliveryHours_hint__WjuDv`
};
export default ___CSS_LOADER_EXPORT___;
